import React from 'react';
import Button from 'screens/components/basic/Button';
import LOOKUP from 'constants/lookup';
import TextInput from 'screens/components/basic/TextInput';
import SelectInput from 'screens/components/basic/SelectInput';
import { mapWarehouseFilter } from 'utils/mappers';
import CheckInput from 'screens/components/basic/CheckInput';
import './styles/InventoryAdjust.scss';

const statusOptions = [
    {
        text: "All",
        value: "None"
    },
    {
        text: "Active",
        value: "1"
    },
    {
        text: "Inactive",
        value: "2"
    }
];

const typeOptions = [
    {
        text: "All",
        value: "0"
    },
    {
        text: "Bulk",
        value: "1"
    },
    {
        text: "Unit",
        value: "2"
    },
    {
        text: "Pre-Pack",
        value: "3"
    }
];

const weightoptions = [
    {
        text: "All", value: "0"
    },
    {
        text: "1G", value: "1"
    },
    {
        text: "3.5G", value: "3.5"
    },
    {
        text: "7G", value: "7"
    },
    {
        text: "14G", value: "14"
    },
    {
        text: "15G", value: "15"
    },
    {
        text: "28G", value: "28"
    },
    {
        text: "30G", value: "30"
    }
];

const productPropertyStatus = [
    {
        text: "All",
        value: "0"
    },
    {
        text: "Yes",
        value: "1"
    },
    {
        text: "No",
        value: "2"
    }
];

const species = [
    {
        text: "All",
        value: "0"
    },
    {
        text: "Indica",
        value: "1"
    },
    {
        text: "Hybrid",
        value: "2"
    },
    {
        text: "Sativa",
        value: "3"
    },
    {
        text: "CBD",
        value: "4"
    },
    {
        text: "Blend",
        value: "5"
    },
    {
        text: "Others",
        value: "6"
    }];


const Header = (props) => {
    let warehouseOptions = mapWarehouseFilter(props.warehouses);
    return (
        <div>
            {/* Search Inputs */}
            <div className="row m-0">
                <div className="col-xs-6 col-sm-3">
                    <TextInput
                        name={`${props.pageName}NameFilter`}
                        fullWidth={true}
                        className="search-field"
                        label={LOOKUP.product.inventoryAdjustFilters.name.label}
                        floatingLabelText={LOOKUP.product.inventoryAdjustFilters.name.label}
                        hintText={LOOKUP.product.inventoryAdjustFilters.name.hintText}
                        onPressKey={props.search} />
                </div>
                <div className="col-xs-6 col-sm-3">
                    <TextInput
                        name={`${props.pageName}SKUFilter`}
                        className="search-field"
                        label={LOOKUP.product.inventoryAdjustFilters.sku.label}
                        floatingLabelText={LOOKUP.product.inventoryAdjustFilters.sku.label}
                        hintText={LOOKUP.product.inventoryAdjustFilters.sku.hintText}
                        onPressKey={props.search} />
                </div>
                <div className="col-xs-6 col-sm-3">
                    <SelectInput
                        name={`${props.pageName}CategoryFilter`}
                        fullWidth={true}
                        className="search-field"
                        floatingLabelText={LOOKUP.product.inventoryAdjustFilters.category.label}
                        options={props.categories}
                        hintText={LOOKUP.product.inventoryAdjustFilters.category.hintText}
                        defaultValue="0" />
                </div>
                <div className="col-xs-6 col-sm-3">
                    <TextInput
                        type="number"
                        name={`${props.pageName}POFilter`}
                        className="search-field"
                        label={LOOKUP.product.inventoryAdjustFilters.po.label}
                        floatingLabelText={LOOKUP.product.inventoryAdjustFilters.po.label}
                        hintText={LOOKUP.product.inventoryAdjustFilters.po.hintText}
                        onPressKey={props.search} />
                </div>
            </div>
            <div className="row m-0">
                {props.digitalSignageEnabled ?
                    (<div className="col-xs-6 col-sm-3">
                        <TextInput
                            name={`${props.pageName}DisplayNameFilter`}
                            className="search-field"
                            label={LOOKUP.product.inventoryAdjustFilters.displayName.label}
                            floatingLabelText={LOOKUP.product.inventoryAdjustFilters.displayName.label}
                            hintText={LOOKUP.product.inventoryAdjustFilters.displayName.hintText}
                            onPressKey={props.search} />
                    </div>) : null
                }
                <div className="col-xs-6 col-sm-3">
                    <SelectInput
                        name={`${props.pageName}Warehouse`}
                        className="search-field"
                        label="Warehouse"
                        floatingLabelText="Warehouse (Default Store)"
                        options={warehouseOptions}
                    />
                </div>
                <div className="col-xs-6 col-sm-3">
                    <SelectInput
                        name={`${props.pageName}Status`}
                        className="search-field"
                        label="Product Status"
                        floatingLabelText="Product Status"
                        defaultValue="None"
                        options={statusOptions} />
                </div>
                <div className="col-xs-6 col-sm-3">
                    <SelectInput
                        name={`${props.pageName}Type`}
                        className="search-field"
                        label="Product Type"
                        floatingLabelText="Product Type"
                        defaultValue="0"
                        options={typeOptions}
                    />
                </div>
                <div className="col-xs-6 col-sm-3">
                    <SelectInput
                        name={`${props.pageName}HasWeight`}
                        className="search-field"
                        label="Weight Available"
                        floatingLabelText="Weight Available"
                        defaultValue="0"
                        options={productPropertyStatus}
                    />
                </div>
                <div className="col-xs-6 col-sm-3">
                    <SelectInput
                        name={`${props.pageName}HasImage`}
                        className="search-field"
                        label="Image Available"
                        floatingLabelText="Image Available"
                        defaultValue="0"
                        options={productPropertyStatus}
                    />
                </div>
                <div className="col-xs-6 col-sm-3">
                    <SelectInput
                        name={`${props.pageName}DigitalSignageEnabled`}
                        className="search-field"
                        label="Digital Signage Enabled"
                        floatingLabelText="Digital Signage Enabled"
                        defaultValue="0"
                        options={productPropertyStatus}
                    />
                </div>
                <div className="col-xs-6 col-sm-3">
                    <SelectInput
                        name={`${props.pageName}WebmenuEnabled`}
                        className="search-field"
                        label="Web Menu Enabled"
                        floatingLabelText="Web Menu Enabled"
                        defaultValue="0"
                        options={productPropertyStatus}
                    />
                </div>
                <div className="col-xs-6 col-sm-3">
                    <SelectInput
                        name={`${props.pageName}Weight`}
                        className="search-field"
                        label="Weight"
                        floatingLabelText="Weight"
                        defaultValue="0"
                        options={weightoptions}
                    />
                </div>
                <div className="col-xs-6 col-sm-3">
                    <SelectInput
                        name={`${props.pageName}Location`}
                        className="search-field"
                        label="Location"
                        floatingLabelText="Location"
                        defaultValue="0"
                        options={props.locations}
                    />
                </div>
                <div className="col-xs-6 col-sm-6">
                    <SelectInput
                        name={`${props.pageName}Branch`}
                        className="search-field"
                        label="Branch"
                        floatingLabelText="Branch"
                        options={props.branchOptions}
                    />
                </div>
                {props.isVape ? null : (
                    <div className="col-xs-6 col-sm-3">
                        <SelectInput
                            name={`${props.pageName}SpeciesFilter`}
                            fullWidth={true}
                            className="search-field"
                            floatingLabelText={LOOKUP.product.inventoryAdjustFilters.species.label}
                            options={species}
                            hintText={LOOKUP.product.inventoryAdjustFilters.species.hintText}
                            defaultValue="0" />
                    </div>
                )}
                <div className="col-xs-6 col-sm-3">
                    <TextInput
                        name={`${props.pageName}UniversalProductCode`}
                        fullWidth={true}
                        className="search-field"
                        label="Universal Product Code"
                        floatingLabelText="Universal Product Code" />

                </div>
            </div>
            {/* Checkboxes */}
            <div className="row m-0">
                <div className="col-sm-6"></div>
                <div className="col-sm-3 p-0">
                    <CheckInput name={props.pageName + "ShowAdvancedOptions"} text={LOOKUP.product.inventoryAdjustFilters.showAdvancedCheckbox} className="check-boxes float-R" />
                </div>
                <div className="col-sm-3 p-0">
                    <CheckInput name={props.pageName + "ShowOnlyInStock"} text={LOOKUP.product.inventoryAdjustFilters.showOnlyInStockToggle} className="check-boxes float-R" />
                </div>
            </div>
            {/*Buttons*/}
            <div className="row m-0">
                <div className="col-sm-12 text-right mt-2">
                    <Button
                        type="IconSearchButton"
                        id="buttonSearchProduct"
                        label={LOOKUP.product.inventoryAdjustFilters.filterButton}
                        className="btnNewBrandPOS"
                        onTouchTap={props.search} />
                    <Button
                        className="ml-2"
                        type="IconClearButton"
                        label={LOOKUP.product.inventoryAdjustFilters.cleanFilterButton}
                        onTouchTap={props.cleanSearch} />
                </div>
            </div>
            <div className="row m-0 purpleText font-italic">
                <div className="col-sm-12">
                    <p><b>Note: </b>Please <strong className="danger">"Save Changes"</strong> before you switch pages.</p>
                    <p>Please select a specific lot number under Product Info section if you want to check/update the THC & CBD Exact values.</p>
                    <p>The default THC/CBD MAX & MIN values come from product catalogue and won't be automatically updated. Rounding prices of individual products must be saved after rounding.</p>
                    <p>"Restock Cap" is used in "Re-stock By Caps" report.</p>
                    <p>Margin and markup are calculated from regular selling price, regular and member price must greater than zero.</p>
                </div>
            </div>
        </div>
    );
};


export default Header;